import { render, staticRenderFns } from "./consumeone.vue?vue&type=template&id=4080f503&scoped=true&"
import script from "./consumeone.vue?vue&type=script&lang=js&"
export * from "./consumeone.vue?vue&type=script&lang=js&"
import style0 from "./consumeone.vue?vue&type=style&index=0&id=4080f503&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080f503",
  null
  
)

export default component.exports